import {
  Autosuggest,
  Box,
  filterSuggestions,
  IconSearch,
} from 'braid-design-system';
import { useEffect, useMemo, useState } from 'react';

import { makePartnerSuggestions } from 'src/pages/ConnectedPartners/components/SearchFilter/makePartnerSuggestions';
import type { Partner } from 'src/types';
import { useQueryHistory } from 'src/utils/hooks/useQueryHistory';

interface Props {
  partners: Partner[];
  selected?: Partner;
}

interface AutosuggestValue {
  text: string;
  value?: Partner;
}

export const ReleasePartnerFilter = ({ partners, selected }: Props) => {
  const { set, delete: qhDelete } = useQueryHistory('p');

  const [value, setValue] = useState<AutosuggestValue>({ text: '' });

  const partnerSuggestions = useMemo(
    () => makePartnerSuggestions(partners || []),
    [partners],
  );

  const onSearchValueChange = (newSuggestVal: AutosuggestValue) => {
    setValue(newSuggestVal);

    const selectedPartner = newSuggestVal.value;
    if (selectedPartner) {
      set(selectedPartner.slug);
    }
  };

  const clearSearch = () => {
    setValue({ text: '' });
    qhDelete();
  };

  /**
   * Update the search value when the query changes.
   * This keeps the search value up to date when using browser back/forward buttons.
   */
  useEffect(() => {
    setValue({ text: selected?.name || '' });
  }, [selected?.name]);

  return (
    <Box paddingY="medium">
      <Autosuggest<Partner>
        id="release-notes-partners"
        type="search"
        label="Provider"
        placeholder="Select a provider"
        icon={<IconSearch />}
        value={value}
        onClear={clearSearch}
        onChange={onSearchValueChange}
        suggestions={filterSuggestions(partnerSuggestions, value.text)}
        automaticSelection={true}
      />
    </Box>
  );
};
